import { TripTypeEnum } from '@mopla/data-models';

/** How a leg's price has to be presented. */
export enum EPriceInfoKind {
	amount = 'amount',
	tariff = 'tariff',
	free = 'free',
	/** Not a paid transport leg at all (walks, technical legs). */
	none = 'none',
}

/**
 * Classifies a leg by its mode, for the pre-booking flow where no leg carries a
 * price yet. A booked ride is not classified here at all — the backend states
 * its `PriceType` per leg and per booking.
 * Not `Partial`: a new BE mode must break the TS.
 */
const MODE_TO_KIND: Record<TripTypeEnum, EPriceInfoKind> = {
	[TripTypeEnum.PRODT]: EPriceInfoKind.amount,
	[TripTypeEnum.LBODTFLEX]: EPriceInfoKind.amount,
	[TripTypeEnum.LBT]: EPriceInfoKind.tariff,
	[TripTypeEnum.LBODT]: EPriceInfoKind.tariff,
	[TripTypeEnum.LBODTDS]: EPriceInfoKind.tariff,
	[TripTypeEnum.POOLODT]: EPriceInfoKind.tariff,
	[TripTypeEnum.OTHERS]: EPriceInfoKind.tariff,
	[TripTypeEnum.UNCATEGORIZED]: EPriceInfoKind.tariff,
	[TripTypeEnum.SPECIAL_SCHOOL_TRAFFIC]: EPriceInfoKind.free,
	[TripTypeEnum.WALK]: EPriceInfoKind.none,
	[TripTypeEnum.TRANSFER_WALK]: EPriceInfoKind.none,
	[TripTypeEnum.EMPTY]: EPriceInfoKind.none,
	[TripTypeEnum.BLOCKER]: EPriceInfoKind.none,
};

export const getPriceInfoKind = (mode: TripTypeEnum): EPriceInfoKind =>
	MODE_TO_KIND[mode] ?? EPriceInfoKind.none;
